import { h } from "preact";
import { useMemo } from "preact/hooks";
import { DynamicFile, FilePickerAcceptType, NativeFileHandle } from "./DynamicFile";
import { useCommandHandler, useForceUpdate } from "../hooks";
import { Command } from "../hooks/Command";

export function DynamicFileInput(props: { onChange: (data: File[]) => void, allowReload?: boolean, allowClear?: boolean, displayName?: boolean, doClear?: Command, types?: FilePickerAcceptType[] }) {
    const dynamicFile = useMemo(() => new DynamicFile(), [true]);
    const forceUpdate = useForceUpdate();

    useCommandHandler(props.doClear, () => {
        dynamicFile.close();
        props.onChange([]);
    });

    return <div>
        <button type="button" onClick={async (e) => {
            await dynamicFile.open(props.types);

            if (!dynamicFile.isOpened) {
                props.onChange([]);
                return;
            }

            props.onChange([
                await dynamicFile.readFile()
            ]);

            forceUpdate();
        }}>Otwórz plik</button>
        {props.allowReload !== false ? <button type="button" class={dynamicFile.isOpened ? "" : "disabled"} style="margin-left: 10px;" onClick={async () => {
            if (!dynamicFile.isOpened) {
                props.onChange([]);
                return;
            }

            props.onChange([
                await dynamicFile.readFile()
            ]);
        }}>Przeładuj</button> : null}
        {props.allowClear !== false ? <button type="button" class={"error" + (dynamicFile.isOpened ? "" : " disabled")} style="margin-left: 10px; margin-right: 10px;" onClick={async () => {
            dynamicFile.close();
            props.onChange([]);
        }}>Wyczyść</button> : null}
        {props.displayName !== false ? <div style="margin-left: 10px; margin-bottom: 10px;">{dynamicFile.isOpened ? dynamicFile.name : ""}</div> : null}
    </div>;
}

export function DynamicWriteableFileInput(props: { onChange: (file: DynamicFile | null) => void, displayName?: boolean, types?: FilePickerAcceptType[] }) {
    const dynamicFile = useMemo(() => new DynamicFile(), [true]);
    const forceUpdate = useForceUpdate();

    return <div>
        <button type="button" onClick={async (e) => {
            await dynamicFile.open(props.types);

            if (!dynamicFile.isOpened) {
                props.onChange(null);
                return;
            }

            props.onChange(dynamicFile);

            forceUpdate();
        }}>Otwórz plik</button>
        <button type="button" class={dynamicFile.isOpened ? "" : "disabled"} style="margin-left: 10px;" onClick={async () => {
            if (!dynamicFile.isOpened) {
                props.onChange(null);
                return;
            }

            props.onChange(dynamicFile);
        }}>Przeładuj</button>
        <button type="button" class={"error" + (dynamicFile.isOpened ? "" : " disabled")} style="margin-left: 10px; margin-right: 10px;" onClick={async () => {
            dynamicFile.close();
            props.onChange(null);
        }}>Wyczyść</button>
        <div style="margin-top: 10px">Załadowany szablon:</div>
        {props.displayName !== false ? <div style="margin-left: 10px; margin-bottom: 10px;">{dynamicFile.isOpened ? dynamicFile.name : ""}</div> : null}
    </div>;
}
